import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "../container/Login/Signin/login";
import Forgot from "../container/Login/forgotPassword";
import MainSiteDashboard from "../container/Login/mainSiteDashboard";
import RedirectMainSite from "../container/Login/RedirectCreatePassword/RedirectMainSite";
import TwoStepVerificationOTP from "../container/Login/Signin/TwoStepVerificationOTP";
import Welcome from "../container/Login/Login/Welcome";

const UnAuthenticationRoutes = () => {
  return (
    <>
      <Router>
        <Routes>
          <Route path="*" element={<Welcome/>} />
          <Route path="/" element={<Welcome/>} />
          <Route exact path="/login" element={<Welcome/>} />
          {/* <Route path="*" element={<Login />} />
          <Route path="/" element={<Login />} />
          <Route exact path="/login" element={<Login />} /> */}
          <Route path="/forgot-password" element={<Forgot />} />
          <Route
            path="/create-password/:uidb64/:token/"
            element={<RedirectMainSite />}
          />
          <Route
            path="/twoStep-Verification-OTP"
            element={<TwoStepVerificationOTP />}
          />
          <Route path="/redirect/:token" element={<MainSiteDashboard />} />
        </Routes>
      </Router>
    </>
  );
};

export default UnAuthenticationRoutes;
